import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { useI18n } from '@/helpers/composables/useI18n';
import { storeToRefs } from 'pinia';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'TitlesCount',
  props: {
    count: { default: 0 }
  },
  setup(__props: any) {

const props = __props as { count: number };



const { language } = storeToRefs(useLanguageStore());
const { t } = useI18n();

const titleCountLabel = computed(() => {
	// Trick to print title count when running e2e tests
	if (global.VUE_APP_TESTS_E2E) {
		return props.count;
	}

	const integerFormat = new Intl.NumberFormat(language.value);
	const localizedCount = integerFormat.format(props.count);

	return props.count === 1
		? t('WEBAPP_TITLE', { NUMBER: localizedCount })
		: t('WEBAPP_TITLES', { NUMBER: localizedCount });
});

return { __sfc: true,props, language, t, titleCountLabel }
}

})